import type {
  CampusAlert,
  CounsellingSlot,
  FeedbackThread,
  SafetyIncident,
  WellbeingResource,
} from '../types/campus'

export const alerts: CampusAlert[] = [
  {
    id: 'alt-1',
    title: 'Power cable repair at Akoka gate 2',
    detail: 'Gate 2 is closed to pedestrians and vehicles until 18:00. Use gate 1.',
    severity: 'critical',
    issued: '18 min ago',
    area: 'Akoka Main Campus',
  },
  {
    id: 'alt-2',
    title: 'Reported phone snatching along Iwaya Road',
    detail: 'Two incidents reported after 21:00 this week. Avoid walking alone at night on that stretch.',
    severity: 'warning',
    issued: 'Yesterday',
    area: 'Iwaya / Onike',
  },
  {
    id: 'alt-3',
    title: 'Fire drill — Engineering complex',
    detail: 'Scheduled evacuation drill on Friday at 11:00. Expect alarms for 20 minutes.',
    severity: 'info',
    issued: '2 days ago',
    area: 'Faculty of Engineering',
  },
]

export const emergencyContacts = [
  { label: 'Campus security control room', value: '+234 803 000 1111', note: 'Answers 24 hours' },
  { label: 'University health centre', value: '+234 803 000 2222', note: '24-hour emergency wing' },
  { label: 'Nigeria emergency line', value: '112', note: 'Police, fire, ambulance' },
  { label: 'Student welfare officer', value: '+234 803 000 3333', note: 'Mon — Fri, 08:00 — 17:00' },
]

export const myIncidents: SafetyIncident[] = [
  {
    id: 'inc-1',
    reference: 'SF-20481',
    category: 'Theft',
    location: 'Faculty of Engineering car park',
    reported: '4 Aug 2026',
    anonymous: false,
    status: 'Assigned',
  },
  {
    id: 'inc-2',
    reference: 'SF-20369',
    category: 'Unsafe street lighting',
    location: 'Iwaya Road footpath',
    reported: '21 Jul 2026',
    anonymous: true,
    status: 'Resolved',
  },
]

export const trustedContacts = [
  { name: 'Ngozi Obi', relationship: 'Parent', phone: '+234 802 111 4455' },
  { name: 'Ifeoma E.', relationship: 'Course mate', phone: 'Shared on alert only' },
]

export const feedbackThreads: FeedbackThread[] = [
  {
    id: 'fb-1',
    subject: 'CSC 321 lab sessions are oversubscribed',
    target: 'Department of Computer Sciences',
    kind: 'Course feedback',
    visibility: 'Public',
    submitted: '6 Aug 2026',
    status: 'Acknowledged',
    responseDays: 3,
  },
  {
    id: 'fb-2',
    subject: 'Hostel water supply cuts out in the evening',
    target: 'Student Affairs — Accommodation',
    kind: 'Accommodation',
    visibility: 'Private',
    submitted: '29 Jul 2026',
    status: 'Open',
  },
  {
    id: 'fb-3',
    subject: 'Library reading room needs more power sockets',
    target: 'University Library',
    kind: 'Facility',
    visibility: 'Public',
    submitted: '14 Jul 2026',
    status: 'Resolved',
    responseDays: 11,
  },
]

export const openSurveys = [
  {
    id: 'srv-1',
    title: 'First semester course evaluation',
    owner: 'Academic Planning Unit',
    closes: 'Closes 22 Aug',
    minutes: 6,
    anonymous: true,
  },
  {
    id: 'srv-2',
    title: 'Campus accommodation experience 2026',
    owner: 'Student Affairs',
    closes: 'Closes 30 Aug',
    minutes: 4,
    anonymous: true,
  },
]

export const wellbeingResources: WellbeingResource[] = [
  {
    id: 'wb-1',
    title: 'Managing exam pressure without burning out',
    kind: 'Article',
    minutes: 7,
    summary: 'Practical routines for revision weeks, written with the university counselling unit.',
  },
  {
    id: 'wb-2',
    title: 'Five-minute grounding exercise',
    kind: 'Audio guide',
    minutes: 5,
    summary: 'A short breathing and grounding track for moments of acute stress.',
  },
  {
    id: 'wb-3',
    title: 'How am I doing? Wellbeing check-in',
    kind: 'Self check',
    minutes: 4,
    summary: 'A reflective check-in. It is not a diagnosis and results stay private to you.',
  },
  {
    id: 'wb-4',
    title: 'Sleep and study workshop',
    kind: 'Workshop',
    minutes: 45,
    summary: 'Weekly in-person session at the health centre, no booking required.',
  },
]

export const counsellingSlots: CounsellingSlot[] = [
  {
    id: 'cs-1',
    counsellor: 'Dr. Amina Yusuf',
    specialism: 'Academic stress, anxiety',
    mode: 'In person',
    nextAvailable: 'Fri 14 Aug, 11:00',
  },
  {
    id: 'cs-2',
    counsellor: 'Mr. Peter Okafor',
    specialism: 'Adjustment, relationships',
    mode: 'Video call',
    nextAvailable: 'Mon 17 Aug, 15:30',
  },
  {
    id: 'cs-3',
    counsellor: 'Mrs. Halima Sule',
    specialism: 'Grief, low mood',
    mode: 'In person',
    nextAvailable: 'Tue 18 Aug, 09:00',
  },
]
